"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "teamsDarkTheme", {
    enumerable: true,
    get: function() {
        return teamsDarkTheme;
    }
});
const _createTeamsDarkTheme = require("../../utils/createTeamsDarkTheme");
const _brandColors = require("../../global/brandColors");
const teamsDarkTheme = (0, _createTeamsDarkTheme.createTeamsDarkTheme)(_brandColors.brandTeams);
